export default __webpack_public_path__ + "static/media/satelite.04549656.jpeg";